/* Sauer's Bakehouse — "Added to cart!" feedback.
   When an add-to-cart button is clicked the theme shows its built-in loading
   spinner, and once the /cart/add request succeeds we:
     1. flip the same button to the brand eucalyptus green with a check +
        "Added to cart!", then revert after a moment;
     2. slide in a small "Added to cart" toast popup that fades away on its own
        (client request — Update 2, page 1); and
     3. dispatch a `cart:updated` event so the header cart-count pill refreshes
        live without a page reload (client request — Update 2, page 1).
   Works for the main product button, the sticky mobile bar, quick-add buttons,
   and the bundle builder (Eurus `eurus:cart:add-as-bundle`). Hooks both fetch
   and XMLHttpRequest. */
(function () {
  if (window.__srAtcFeedback) return;
  window.__srAtcFeedback = true;

  var GREEN = 'var(--sr-sage, #2C6E63)';
  var ON_GREEN = 'var(--sr-paper, #FBF2DC)';
  var css = ''
    + 'button.sr-atc-done,.sr-atc-done.button,.sr-atc-done.add_to_cart_button{'
    +   'background-color:' + GREEN + '!important;background-image:none!important;'
    +   'border-color:' + GREEN + '!important;color:' + ON_GREEN + '!important;'
    +   'transition:background-color .25s ease,border-color .25s ease,color .25s ease}'
    + '.sr-atc-done .x-atc-text,.sr-atc-done .button-text{color:' + ON_GREEN + '!important}'
    + '.sr-atc-check{width:16px;height:16px;margin-right:7px;vertical-align:-3px;display:inline-block;'
    +   'animation:sr-atc-pop .35s cubic-bezier(.18,.89,.32,1.28) both}'
    + '@keyframes sr-atc-pop{0%{transform:scale(.4);opacity:0}100%{transform:scale(1);opacity:1}}'
    // ── Floating "Added to cart" toast popup ──
    + '.sr-toast{position:fixed;z-index:99999;left:50%;bottom:26px;transform:translate(-50%,24px);'
    +   'display:flex;align-items:center;gap:12px;max-width:min(92vw,380px);'
    +   'background:var(--sr-ink,#1E2F58);color:var(--sr-paper,#FBF2DC);'
    +   'border-radius:14px;padding:13px 18px;'
    +   'box-shadow:0 14px 40px rgba(30,47,88,.32),0 2px 0 rgba(0,0,0,.06);'
    +   'font-family:var(--font-body-family,inherit);opacity:0;pointer-events:none;'
    +   'transition:opacity .3s ease,transform .3s cubic-bezier(.18,.89,.32,1.28)}'
    + '.sr-toast.is-in{opacity:1;transform:translate(-50%,0);pointer-events:auto}'
    + '.sr-toast__ic{flex:0 0 auto;width:28px;height:28px;border-radius:50%;'
    +   'background:var(--sr-sage,#2C6E63);color:var(--sr-paper,#FBF2DC);'
    +   'display:flex;align-items:center;justify-content:center}'
    + '.sr-toast__ic svg{width:16px;height:16px}'
    + '.sr-toast__tx{display:flex;flex-direction:column;line-height:1.25;min-width:0}'
    + '.sr-toast__t{font-weight:700;font-size:14px}'
    + '.sr-toast__s{font-size:12px;opacity:.8}'
    + '.sr-toast__cta{margin-left:6px;flex:0 0 auto;color:var(--sr-yellow,#EFC233);'
    +   'font-weight:700;font-size:12px;text-transform:uppercase;letter-spacing:.04em;'
    +   'text-decoration:none;white-space:nowrap}'
    + '.sr-toast__cta:hover{text-decoration:underline}'
    + '@media (max-width:600px){.sr-toast{bottom:calc(16px + env(safe-area-inset-bottom,0px))}}'
    + '@media (prefers-reduced-motion:reduce){.sr-atc-check{animation-duration:.01ms!important}'
    +   '.sr-toast{transition:opacity .2s ease}}';

  function injectStyle() {
    if (document.getElementById('sr-atc-style')) return;
    var s = document.createElement('style');
    s.id = 'sr-atc-style';
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }

  var CHECK = '<svg class="sr-atc-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" '
    + 'stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg>';
  var CHECK_PLAIN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" '
    + 'stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg>';

  // ── Floating toast popup that fades in then fades away ──
  var toastEl = null, toastTimer = null, toastHideTimer = null;
  function cartUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root : '/') .replace(/\/$/, '') + '/cart';
  }
  function showToast(title, sub) {
    injectStyle();
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'sr-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML =
      '<span class="sr-toast__ic">' + CHECK_PLAIN + '</span>'
      + '<span class="sr-toast__tx"><span class="sr-toast__t">' + (title || 'Added to cart!') + '</span>'
      + (sub ? '<span class="sr-toast__s">' + sub + '</span>' : '') + '</span>'
      + '<a class="sr-toast__cta" href="' + cartUrl() + '">View cart</a>';
    clearTimeout(toastTimer); clearTimeout(toastHideTimer);
    // force reflow so the enter transition always plays, even on rapid re-adds
    void toastEl.offsetWidth;
    toastEl.classList.add('is-in');
    toastTimer = setTimeout(function () {
      if (toastEl) toastEl.classList.remove('is-in');
    }, 2600);
  }

  var SAGE = '#2C6E63', CREAM = '#FBF2DC';
  function paint(btn, textEl) {
    // Inline !important beats the theme's brand button colours regardless of specificity.
    btn.style.setProperty('background-color', SAGE, 'important');
    btn.style.setProperty('background-image', 'none', 'important');
    btn.style.setProperty('border-color', SAGE, 'important');
    btn.style.setProperty('color', CREAM, 'important');
    textEl.style.setProperty('color', CREAM, 'important');
  }
  function unpaint(btn, textEl) {
    ['background-color', 'background-image', 'border-color', 'color'].forEach(function (p) { btn.style.removeProperty(p); });
    textEl.style.removeProperty('color');
  }

  function showSuccess(btn, label) {
    if (!btn) return;
    var textEl = btn.querySelector('.x-atc-text') || btn.querySelector('.button-text');
    if (!textEl) return; // don't risk clobbering the spinner / Alpine bindings
    injectStyle();
    clearTimeout(btn.__srTimer);
    if (btn.__srOrigHTML == null) btn.__srOrigHTML = textEl.innerHTML;
    // Apply just after Alpine clears its `loading` flag so the label is visible.
    setTimeout(function () {
      var wrap = textEl.parentElement;
      if (wrap && wrap.classList.contains('invisible')) wrap.classList.remove('invisible');
      textEl.innerHTML = CHECK + (label || 'Added to cart!');
      btn.classList.add('sr-atc-done');
      paint(btn, textEl);
    }, 60);
    btn.__srTimer = setTimeout(function () {
      if (btn.__srOrigHTML != null) textEl.innerHTML = btn.__srOrigHTML;
      btn.classList.remove('sr-atc-done');
      unpaint(btn, textEl);
      btn.__srOrigHTML = null;
    }, 2400);
  }

  // Track the add-to-cart button the shopper most recently triggered.
  var lastBtn = null, lastAt = 0;
  document.addEventListener('click', function (e) {
    var b = e.target.closest('button[name="add"], .add_to_cart_button, [data-add-to-cart]');
    if (b) { lastBtn = b; lastAt = new Date().getTime(); }
  }, true);

  var firing = 0;
  function fireSuccess(label) {
    var now = new Date().getTime();
    if (now - firing < 800) return;        // debounce duplicate hooks for one add
    firing = now;
    // 1) button flip (immediate, local confirmation)
    if (lastBtn && now - lastAt < 12000) showSuccess(lastBtn, label);
    // 2) floating toast popup that fades away
    showToast(label || 'Added to cart!', 'Nice pick — it’s in your bag.');
    // 3) refresh the header cart-count pill live (no page reload). The header
    //    listens for `cart:updated`; also nudge the Eurus cart drawer.
    try {
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('cart:change'));
    } catch (e) {}
    refreshCartCounts();
  }

  // Belt-and-suspenders: update every cart-count element on the page directly,
  // in case a section isn't wired to the cart:updated listener.
  function refreshCartCounts() {
    var url = cartUrl() + '.js';
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (!c || typeof c.item_count !== 'number') return;
        var sel = '[data-cart-count],.cart-count,.count-cart,.pill-count,[data-cart-item-count]';
        [].forEach.call(document.querySelectorAll(sel), function (el) {
          el.textContent = c.item_count;
          el.classList.remove('hidden', 'empty');
        });
      }).catch(function () {});
  }

  function isCartAddUrl(url) { return /\/cart\/add(\.js)?(\?|$)/.test(url || ''); }
  function labelFor(body) {
    try {
      if (typeof body === 'string' && body) {
        var p = JSON.parse(body);
        if (p && Array.isArray(p.items) && p.items.length > 1) return 'Added to cart!';
      }
    } catch (e) {}
    return 'Added to cart!';
  }

  // 1) Eurus bundle event
  document.addEventListener('eurus:cart:add-as-bundle', function () { fireSuccess('Added to cart!'); });

  // 2) fetch
  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var method = ((init && init.method) || (typeof input === 'object' && input && input.method) || 'GET') + '';
      var isAdd = isCartAddUrl(url) && /post/i.test(method);
      var label = isAdd ? labelFor(init && init.body) : null;
      var p = origFetch.apply(this, arguments);
      if (isAdd) p.then(function (r) { if (r && (r.ok || r.status === 200)) fireSuccess(label); }).catch(function () {});
      return p;
    };
  }

  // 3) XMLHttpRequest
  var XHR = window.XMLHttpRequest;
  if (XHR && XHR.prototype) {
    var origOpen = XHR.prototype.open, origSend = XHR.prototype.send;
    XHR.prototype.open = function (method, url) {
      this.__srAddUrl = url; this.__srAddMethod = (method || '') + '';
      return origOpen.apply(this, arguments);
    };
    XHR.prototype.send = function (body) {
      var self = this;
      if (isCartAddUrl(self.__srAddUrl) && /post/i.test(self.__srAddMethod)) {
        var label = labelFor(body);
        self.addEventListener('load', function () {
          if (self.status >= 200 && self.status < 300) fireSuccess(label);
        });
      }
      return origSend.apply(this, arguments);
    };
  }
})();
